module.exports = __webpack_public_path__ + "img/horizontal_3_6_5010.fca45b24.png";